import GAuth from 'vue-google-oauth2'
import Vue from 'vue'

const gauthOption = {
  clientId: '570852433891-ufqsaouf1i04tmp9tj8rjq6orj1pd852.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(GAuth, gauthOption)